import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const AnnouncementBlock = makeShortcode("AnnouncementBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnnouncementBlock slots="heading, text, button" variantStyleFill='outline' variantsTypePrimary='secondary' className='ms-announcement-blade' mdxType="AnnouncementBlock" />
    <h3 {...{
      "id": "try-adobe-acrobat-sign-workflow-automation-integrated-with-microsoft-power-automate"
    }}>{`Try Adobe Acrobat Sign Workflow Automation integrated with Microsoft Power Automate.`}</h3>
    <p>{`Goodbye, repetitive tasks. Now, use Power Automate from within Acrobat Sign.`}</p>
    <p><a parentName="p" {...{
        "href": "https://blog.adobe.com/en/publish/2023/05/23/low-code-end-to-end-e-signature-workflow-automation-within-adobe-acrobat-sign"
      }}>{`Learn more`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      